import React from 'react';
import { Icon } from '@chakra-ui/react';

/**
 * @deprecated since new chevron added, @see ChevronIcon
 */
export const SvgAccordionIcon = (props) => {
  return (
    <Icon viewBox="0 -4 10 14" color="gray.900" {...props}>
      <path
        fill="currentColor"
        d="M-2261.014-1160.7l5.513-3.865a.558.558 0 0 0 0-.977l-5.513-3.865c-.5-.349-1.341-.021-1.177.459a12.006 12.006 0 0 1 .652 3.9 12.006 12.006 0 0 1-.652 3.9c-.163.474.679.802 1.177.448z"
        transform="translate(9) rotate(90) translate(2262.211 1169.549)"
      />
    </Icon>
  );
};
